const VALID_PARTNERS = [
  'BM',
  'DI',
  'BMUK',
  'BMJP',
  'RF',
  'YA',
  'MI',
  'FN',
  'SA',
  'DICH',
  'MO',
  'RFWE',
  'OP',
];

export const getPartnerFromHostname = hostname => {
  const parts = hostname.split('-');

  const envIndex = parts.findIndex(
    part => part === 'staging' || part === 'preproduction',
  );

  if (envIndex !== -1 && envIndex + 1 < parts.length) {
    const partnerPart = parts[envIndex + 1].split('.')[0].toUpperCase();

    if (VALID_PARTNERS.includes(partnerPart)) {
      return partnerPart;
    } else {
      return 'BM';
    }
  }

  const lastPart = parts[parts.length - 1];
  if (
    lastPart &&
    (lastPart.startsWith('staging.') || lastPart.startsWith('preproduction.'))
  ) {
    return 'BM';
  }

  const fallbackPartner = parts[4]?.split('.')?.[0]?.toUpperCase();

  if (fallbackPartner && VALID_PARTNERS.includes(fallbackPartner)) {
    return fallbackPartner;
  } else {
    return 'BM';
  }
};

export const getPartner = () => {
  const { hostname } = window.location;

  if (hostname === 'localhost') {
    return process.env.PARTNER || 'BM';
  }

  if (hostname.includes('my-customer-space-')) {
    return getPartnerFromHostname(hostname);
  }
  switch (hostname) {
    case 'backmarket.i-surance.eu':
    case 'backmarket.bolttech.eu':
      return 'BM';
    case 'backmarket.i-surance.de':
    case 'backmarket-uk.bolttech.eu':
      return 'BMUK';
    case 'galaxus.bolttech.eu':
      return 'DI';
    case 'refurbed.bolttech.eu':
      return 'RF';
    case 'backmarket.bolttech.jp':
      return 'BMJP';
    case 'mobile.monacocare.mc':
    case 'www.mobile.monacocare.mc':
      return 'MO';
    case 'caresupport.ch':
    case 'www.caresupport.ch':
      return 'SA';
    case 'fnaccare.ch':
      return 'FN';
    case 'insurance.digitec.ch':
      return 'DICH';
    case 'yalloprotect360.ch':
      return 'YA';
    case 'microspot-careplus.ch':
      return 'MI';
    case 'refurbedguarantee.bolttech.eu':
      return 'RFWE';
    default:
      return 'BM';
  }
};
